export const PRIMARY_BUTTON_CLICKED_MODAL_EVENT = "primary-button-clicked-modal-event";
export const SECONDARY_BUTTON_CLICKED_MODAL_EVENT = "secondary-button-clicked-modal-event";
export const CLOSE_BUTTON_CLICKED_MODAL_EVENT = "close-button-clicked-modal-event";
